import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deletePollRequested } from 'features/polls/actions';

export function* deletePollSaga(action: ReturnType<typeof deletePollRequested>) {
  yield call(SignalingSocket.send, { event: 'deletePoll', data: { id: action.payload } });
}
